<template>
<div>
    <v-select
        :label="label"
        :items="choices"
        :multiple="multiple"
        :value="value"
        :clearable="clearable"
        :outlined="outlined"
        :dense="dense"
        :hide-details="hide_details"
        v-on:change="onChange"
    />
</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return 'RedChirp User'; },
        },

        value: {
            type: [String, Array],
            default: function() { return null; },
        },

        multiple: {
            type: Boolean,
            default: function() { return false; },
        },

        clearable: {
            type: Boolean,
            default: function() { return false; },
        },

        outlined: {
            type: Boolean,
            default: function() { return false; },
        },

        dense: {
            type: Boolean,
            default: function() { return false; },
        },

        hide_details: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    model: {
        prop: 'value',
        event: 'change'
    },

    data() {
        return {
            choices: [],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            if ( this.organization_id == null )
            {
                this.choices = [];
                this.internal_value = null;
                return;
            }

            let search = {
                'organization_id' : this.organization_id,
            };
           
            this.$rc.showSpinner();
            
            this.$rc.searchEmployeeLabels(
                search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.choices = this.createChoices(data.results);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to list RedChirp users');
                },
            );
        },

        createChoices(results)
        {
            let ret = [];

            for ( let i = 0; i < results.length; i++ )
            {
                ret.push({
                    'text' : results[i].employee_label,
                    'value' : results[i].employee_id,
                });
            }

            return ret;
        },

        onChange(value)
        {
            this.$emit('change', value);
        },
    },

    computed: {
    },
}
</script>

<style lang="scss" scoped>

</style>